import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 16\" id=\"icon-arrow-right\"><path fill-rule=\"evenodd\" d=\"M10 8L4 3v3H0v4h4v3l6-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol